import { CustomHttpErrorResponse } from '@abb-procure/error-handling';
import {
  HttpErrorResponse,
  type HttpEvent,
  type HttpHandlerFn,
  type HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { type Observable, catchError, throwError } from 'rxjs';
import { SessionsDialogService } from '../services/sessions-dialog.service';

export const concurrentSessionInterceptor = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const sessionsDialogService = inject(SessionsDialogService);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (!(error instanceof HttpErrorResponse)) {
        return throwError(() => error);
      }

      if (error.status === 406) {
        sessionsDialogService.openSessionsDialog();
      }

      return throwError(
        () =>
          new CustomHttpErrorResponse(error.name, error.message, null, {
            ...error,
            url: error.url ?? undefined,
          }),
      );
    }),
  );
};
